import { render, staticRenderFns } from "./AppAdd.vue?vue&type=template&id=b164784c&"
import script from "./AppAdd.vue?vue&type=script&lang=js&"
export * from "./AppAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports